import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, IconButton, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, styled } from '@mui/material';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { IdentificacaoTrabalhador, TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useBlob } from 'esocial.web.react.lib/cjs/hooks/Blob';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { isUndefinedOrNull } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const ContainerBotoesPagina = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(1.5),
    display: 'inline-block',
    float: 'right'
}));

const ContainerBotaoVoltar = styled('div')`
    margin: 48px 0 0;
    display: flex;
`;

const NenhumRegistroEncontrado = styled(Typography)(() => ({
    marginTop: '5rem'
}));

function CatListagem() {
    const { idTrabalhador, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const { get, excluir } = useRequisicaoControlada();
    const navigate = useNavigate();
    const disponibilizarParaDownload = useBlob();
    const dispatch = useAppDispatch();
    const location = useLocation();
    async function excluirCat(idEvento, idContrato, tsv, admPreliminar) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir o registro?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                const aposExclusao = () => {
                    // Tratamento para exclusões executadas via Assinadoc
                    if (location.pathname === '/assinadoc') {
                        navigate(`/cat/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
                    }
                    else {
                        // Atualizar a lista de cats por contrato, removendo o registro excluído
                        setModelo({ ...modelo, listaCatPorContrato: modelo.listaCatPorContrato.filter((x) => x.idEvento !== idEvento) });
                    }
                };

                await excluir(`sst/cat/excluir/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, aposExclusao);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    async function relatorio(idEvento, idContrato, tsv, admPreliminar) {
        await disponibilizarParaDownload(`sst/cat/gerarRelatorio/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, `cat_${idEvento}`, 'pdf', true, { suprimirSobreposicaoMensagens: true });
    }

    async function relatorioEventoRecemRegistrado() {
        // Verificar se há retorno indireto com os parâmetros para geração do relatório
        // Esses parâmetros chegam com a mensagem de sucesso ao fim do registro de uma CAT
        const campoParametrosRelatorioEventoRecemRegistrado = document.getElementById('parametrosRelatorioEventoRecemRegistrado');

        if (!isUndefinedOrNull(campoParametrosRelatorioEventoRecemRegistrado)) {
            const tokens = campoParametrosRelatorioEventoRecemRegistrado.value.split(',');

            if (tokens.length === 4) {
                relatorio(tokens[0], tokens[1], tokens[2], tokens[3]);
            }
        }
    }

    useEffect(() => {
        async function inicializarModelo(idContrato, tsv, admPreliminar) {
            const processamentoResposta = (conteudoResposta) => {
                setModelo(conteudoResposta);
            };

            await get(`sst/cat/obterListaCatPorContrato/${idContrato}/${tsv}/${admPreliminar}`, processamentoResposta, undefined, { suprimirSobreposicaoMensagens: true });
        }

        inicializarModelo(idContrato, tsv, admPreliminar);
    }, []);

    return (
        modelo !== null ?
            <Fragment>
                <TituloPagina>Comunicação de Acidente de Trabalho</TituloPagina>
                <IdentificacaoTrabalhador
                    cpf={modelo.identificacaoTrabalhador.cpf}
                    nome={modelo.identificacaoTrabalhador.nome}
                    categoria={modelo.identificacaoTrabalhador.categoria.codigo}
                    matricula={modelo.identificacaoTrabalhador.matricula} />

                <ContainerBotoesPagina>
                    <Button variant="contained" color="primary"
                        onClick={() => navigate(`/cat/registrar/${idTrabalhador}/0/${idContrato}/${tsv}/${admPreliminar}`)}
                        startIcon={<AddIcon />}>
                        Registrar CAT
                    </Button>
                </ContainerBotoesPagina>

                {
                    modelo.listaCatPorContrato.length > 0 ?
                        <Fragment>
                            <CustomTable>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Data do Acidente</TableCell>
                                        <TableCell align="center">Tipo do Acidente</TableCell>
                                        <TableCell align="center">Tipo de CAT</TableCell>
                                        <TableCell align="center" style={{ width: '300px' }}>Ação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {modelo.listaCatPorContrato.map((linha) => (
                                        <TableRow key={linha.idEvento}>
                                            <TableCell align="center">{(new Date(linha.dataAcidente)).toLocaleDateString('pt-BR')}</TableCell>
                                            <TableCell align="center">{linha.codigoTipoAcidente + ' - ' + linha.descricaoTipoAcidente}</TableCell>
                                            <TableCell align="center">{linha.codigoTipoCat + ' - ' + linha.descricaoTipoCat}</TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="Visualizar">
                                                    <IconButton aria-label="visualizar evento" onClick={() => navigate(`/cat/visualizar/${idTrabalhador}/${linha.idEvento}/${idContrato}/${tsv}/${admPreliminar}`)}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Retificar">
                                                    <IconButton aria-label="retificar evento" onClick={() => navigate(`/cat/retificar/${idTrabalhador}/${linha.idEvento}/${idContrato}/${tsv}/${admPreliminar}`)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Excluir">
                                                    <IconButton aria-label="excluir evento" onClick={() => excluirCat(linha.idEvento, idContrato, tsv, admPreliminar)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title="Gerar Relatório">
                                                    <IconButton aria-label="gerar relatório" onClick={() => relatorio(linha.idEvento, idContrato, tsv, admPreliminar)}>
                                                        <DescriptionIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </CustomTable>
                        </Fragment> :
                        <NenhumRegistroEncontrado>Não há CAT registrada para o(a) trabalhador(a).</NenhumRegistroEncontrado>
                }

                <ContainerBotaoVoltar>
                    <Button variant="outlined" color="secondary" size="medium" onClick={() => {
                        if (tsv == "false") {
                            navigate(`/gestaoTrabalhadores/${idTrabalhador}`);
                        } else {
                            navigate(`/gestaoTrabalhadoresTsv/${idTrabalhador}`);
                        }
                    }}>
                        Voltar
                    </Button>
                </ContainerBotaoVoltar>

                {/*Âncora escondida para disparar indiretamente a geração do relatório do evento recém registrado*/}
                <a id="ancora-gerarRelatorioEventoRecemRegistrado" onClick={() => relatorioEventoRecemRegistrado()} style={{ display: 'none' }} />
            </Fragment> :
            <ContentPreview />
    );
}

export default CatListagem;
